module.exports = __webpack_public_path__ + "static/media/drqwn.6e34f633.jpg";